/**
 * Builds a CSV from an array of rows and triggers a browser download.
 * Uses a Blob (not a data: URL) so large ledgers download reliably in every
 * browser, and prefixes a UTF-8 BOM so Excel opens it with correct encoding.
 * @param {Array<Array<any>>} rows - header row first, then data rows
 * @param {string} filename - e.g. "supplier-ledger-SUP001.csv"
 */
export function downloadCsv(rows, filename) {
  const csv = rows
    .map(r => r.map(c => `"${String(c ?? '').replace(/"/g, '""')}"`).join(','))
    .join('\r\n');
  const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.replace(/[\\/:*?"<>|]/g, '');
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
